import React from 'react';
import { Image } from 'semantic-ui-react'
import logo from '../../styles/img/moxit-logo.png';

export default function NetworkLogo ({network}) {
  const logoUrl = network?.logoUrl || logo
  return (
    <Image src={logoUrl} size="medium" centered />
  )
}